import React from 'react'
import Menu from './Menu'
import { NavLink } from "react-router-dom";

const MenuToggle = () => {

    return (
        <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse"
            data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false"
            aria-label="Toggle navigation">
            <span>Menu</span>
            <i className="fas fa-bars"></i>
        </button>
    )
}

const Navbar = () => {

    return (
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top" id="mainNav">
            <div className="container">
                <a className="navbar-brand js-scroll-trigger" href="#page-top">Paolo Stoppa</a>
                <MenuToggle/>
                <Menu/>
            </div>
        </nav>
    );

}

export default Navbar;